
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-linkedin",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","stroke":"currentColor","fill":"transparent","class":"icon i-linkedin"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.22 20.61h3.61V9.77H4.22zM8.07 6.43a1.87 1.87 0 00-2-1.88A1.88 1.88 0 106 8.3a1.89 1.89 0 002.07-1.87zm9.14 14.18h3.61V14.4c0-3.33-1.78-4.88-4.16-4.88a3.54 3.54 0 00-3.26 1.83V9.77H9.82v10.84h3.61v-6.06a2.36 2.36 0 01.11-.87 2 2 0 011.85-1.32c1.3 0 1.82 1 1.82 2.46v5.79zM24.52 5v15a4.51 4.51 0 01-4.5 4.5H5A4.51 4.51 0 01.52 20V5A4.51 4.51 0 015 .52h15A4.51 4.51 0 0124.52 5z"}})])
          )
        }
      }
    